import InnerComponent from '@Components/Sales/CreditNote/CreditNoteForm';
import orgContainer from '@Components/AppContainer';

const CreateCreditNote = () => ((orgContainer(InnerComponent)));
export default CreateCreditNote;
